import React from "react";
import "./modal.scss";

/* REDUX */
import { useDispatch } from "react-redux";
import { hideModal } from "../../redux/actions";

const Modal = ({ active, size, title, children }) => {
  const dispatch = useDispatch();

  return active ? (
    <div className='modal'>
      <div className={size ? `modal__box--${size}` : `modal__box`}>
        <h2 className='modal__box__title'>{title}</h2>
        <div className='modal__box__content'>{children}</div>
        <span
          className='modal__box__close icon icon--times'
          onClick={() => dispatch(hideModal())}
        ></span>
      </div>
    </div>
  ) : null;
};

export default Modal;
